import React from 'react';
import { Users, Plus } from 'lucide-react';
import { PageTitle } from '../../ui/PageTitle';

interface EmployeesHeaderProps {
  onAddEmployee: () => void;
}

export const EmployeesHeader: React.FC<EmployeesHeaderProps> = ({
  onAddEmployee,
}) => {
  return (
    <div className="mx-2 sm:mx-4 lg:mx-6 mt-2 mb-6">
      <PageTitle
        title="Funcionários"
        subtitle="Gerencie sua equipe"
      >
        <div className="h-12 w-12 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center border border-white/30">
          <Users className="w-7 h-7 text-white" />
        </div>
        
        <button
          onClick={onAddEmployee}
          className="px-4 py-2.5 bg-white/20 backdrop-blur-sm text-white rounded-xl hover:bg-white/30 flex items-center gap-2 font-semibold border border-white/30 transition-all duration-200"
        >
          <Plus className="w-4 h-4" />
          Adicionar
        </button>
      </PageTitle>
    </div>
  );
};
